export default {
	name: 'health-management',
	path: '/health-management',
	redirect: '/health-management/epidemic-report',
	meta: {
		title: '健康管理',
		icon: 'health-management'
	},
	children: [
		{
			name: 'epidemic-report',
			path: 'epidemic-report',
			fullPath: '/health-management/epidemic-report',
			meta: {
				title: '疫情日报'
			},
			component: () =>
				import(/* webpackChunkName: "health-management" */ '@/views/health-management/epidemic-report')
		},
		{
			name: 'heatlth-day',
			path: 'heatlth-day',
			fullPath: '/health-management/heatlth-day',
			meta: {
				title: '健康日报'
			},
			component: () =>
				import(/* webpackChunkName: "health-management" */ '@/views/health-management/heatlth-day')
		}
	]
};
